import React from "react";

export const ProgressBar = ({ section, max, color }) => {
  const percentage = (point, total) => ((point / total) * 100).toFixed(2) + "%";
  const classification = (value) => {
    if (value >= 0 && value <= 3) return "Zayıf";
    if (value === 4) return "Zayıf/Orta";
    if (value >= 5 && value <= 7) return "Orta";
    if (value === 8) return "Orta/Güçlü";
    if (value >= 9 && value <= 11) return "Güçlü";
    return false;
  };
  return (
    <>
      <div
        style={{
          height: "45px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "10px",
          width: "100%",
        }}
      >
        <span className="sub-title">{section[0].title}</span>
        <div className={"progress"}>
          <div
            className={`progress-bar progress-bar-${color[0]}`}
            style={{ width: percentage(section[0].value, max) }}
          >
            {section[0].value}
          </div>
          <div
            className={`progress-bar progress-bar-${color[1]}`}
            style={{ width: percentage(section[1].value, max) }}
          >
            {section[1].value}
          </div>
        </div>
        <span className="sub-title">{section[1].title}</span>
      </div>
      <div className="description">
        <div>
          {section[0].title} : {classification(section[0].value)}
        </div>
        <div>
          {section[1].title} : {classification(section[1].value)}
        </div>
      </div>
      <hr />
    </>
  );
};
